
import AutoTips from '@/components/AutoTips';

export default {
  props: ['label', 'desc'],

  components: {
    AutoTips: AutoTips
  },

  mounted: function mounted() {
    console.log(this.$attrs);
  }
};